// extracted by mini-css-extract-plugin
var _1 = "WhitePaperStyle-module__headline___UfLRY";
var _2 = "WhitePaperStyle-module__white-paper___Kg80i";
var _3 = "WhitePaperStyle-module__white-paper___Kg80i";
export { _1 as "headline", _2 as "white-paper", _3 as "whitePaper" }
